/**
 * Override de proveedor POR SESIÓN (F3-G, profesor/admin): botón "Configurar" que
 * abre un diálogo con los ajustes de proveedor (dirigidos por schema) y guarda
 * con `PUT /api/live/sessions/:id/meeting`. Complementa el default de cohorte.
 */
import { type Component, createSignal, Show } from "solid-js";
import { msg } from "@lingui/core/macro";
import { Settings2 } from "lucide-solid";
import { useI18n } from "@/providers/i18n-provider";
import { Dialog } from "@/components/ui/dialog";
import { MeetingSettings } from "./meeting-settings";
import { liveApi, type LiveApi } from "../lib/live-api";

export interface SessionMeetingButtonProps {
  sessionId: string;
  initialProvider?: string | null;
  api?: LiveApi;
}

export const SessionMeetingButton: Component<SessionMeetingButtonProps> = (props) => {
  const { t } = useI18n();
  const [open, setOpen] = createSignal(false);
  const api = () => props.api ?? liveApi;
  const saveMeeting = async (provider: string, config: Record<string, unknown>) => {
    await api().setMeeting(props.sessionId, provider, config);
    setOpen(false);
  };
  return (
    <>
      <button
        type="button"
        class="inline-flex items-center gap-1 rounded-lg px-2 py-1 text-xs font-medium text-muted-foreground hover:text-foreground"
        data-testid="session-meeting-open"
        aria-label={t(msg`Configure live provider`)}
        onClick={() => setOpen(true)}
      >
        <Settings2 class="h-3.5 w-3.5" /> {t(msg`Configure`)}
      </button>
      <Show when={open()}>
        <Dialog open={open()} onOpenChange={setOpen} contentClass="w-full max-w-md p-4">
          <MeetingSettings
            title={t(msg`Live provider for this session`)}
            initialProvider={props.initialProvider}
            onSave={saveMeeting}
          />
        </Dialog>
      </Show>
    </>
  );
};
